import { render, staticRenderFns } from "./YoubuteVideoCard.vue.js?vue&type=template&id=24f349f0&scoped=true!=!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.4_@rspack+core@2.0.4_@swc+helpers@0.5.21__webpack@5.1_8ecddcfa3a7344e2ed8878aeb6f4a753/node_modules/vue-loader/lib/index.js??vue-loader-options!./YoubuteVideoCard.vue?vue&type=template&id=24f349f0&scoped=true"
var script = {}
import style0 from "./YoubuteVideoCard.vue.postcss?vue&type=style&index=0&id=24f349f0&prod&lang=postcss&scoped=true!=!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.4_@rspack+core@2.0.4_@swc+helpers@0.5.21__webpack@5.1_8ecddcfa3a7344e2ed8878aeb6f4a753/node_modules/vue-loader/lib/index.js??vue-loader-options!./YoubuteVideoCard.vue?vue&type=style&index=0&id=24f349f0&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.4_@rspack+core@2.0.4_@swc+helpers@0.5.21__webpack@5.1_8ecddcfa3a7344e2ed8878aeb6f4a753/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f349f0",
  null
  
)

export default component.exports